import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import Selector from "./Selector";

const BatteryTypeSelector = ({ batteries = [], value = "all", onChange, ...props }) => {
    const [t] = useTranslation();
    const options = useMemo(() => {
        const types = new Map();

        batteries.forEach(battery => {
            const value = battery.batteryType || "unknown";
            types.set(value, {
                value,
                label: battery.batteryTypeDisplayName || battery.batteryType || "t_unknown"
            });
        });

        return [{ value: "all", label: "t_bm_all_battery_types" }, ...types.values()];
    }, [batteries]);

    return <Selector value={value} options={options} onChange={onChange} {...props} />;
};

BatteryTypeSelector.propTypes = {
    batteries: PropTypes.arrayOf(
        PropTypes.shape({
            batteryType: PropTypes.string,
            batteryTypeDisplayName: PropTypes.string
        })
    ),
    value: PropTypes.string,
    onChange: PropTypes.func
};

export default BatteryTypeSelector;
